import { QueryFunctionContext } from '@tanstack/react-query';
import { setCsrfTokenToStorage } from 'common/save-for-later-service';
import _getCsrfToken from 'common/user-service';

export const getCsrfToken = async ({
  queryKey: [, isLocal],
}: QueryFunctionContext<[key: 'csrf', isLocal: boolean]>) => {
  const res = await _getCsrfToken(isLocal);
  setCsrfTokenToStorage(res.csrfToken);
  return res;
};
